// Shared by the app (usePageMeta) and the build-time prerender script, so both
// produce the same titles and tags. Keep this file free of browser-only code.

export const SITE_NAME = 'Sport Sphere';
export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://sport-sphere.co.uk').replace(/\/$/, '');
export const DEFAULT_TITLE = `${SITE_NAME} – find triathlons and races near you`;
export const DEFAULT_DESCRIPTION =
  'Find triathlons and endurance races near you in the UK and Australia. Compare distances, see course maps and get a free AI training plan.';

export const SEARCH_PAGE = {
  path: '/events',
  title: 'Find triathlons and races near you',
  description:
    'Search triathlons and endurance races across the UK and Australia by name, location or organiser, and find events near your postcode.',
};

export const fullTitle = (title?: string) => (title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE);
